import React from 'react';

export default function Badge({ children, variant = 'default', className = '' }) {
  return <span className={`mol-badge mol-badge--${variant} ${className}`}>{children}</span>;
}
